module.exports = __webpack_public_path__ + "img/health-guide-fitosanitaries.00672bf0.png";